import React from 'react';
const Toggle = ({ checked = '', onChange, disabled, large, className = '' }) => {
    const calcBackground = () => {
        if (disabled) {
            return checked ? 'bg-sf-primary-200' : 'bg-sf-gray-200';
        }
        if (checked) return 'bg-sf-primary-500';
        return 'hover:bg-sf-gray-400 bg-sf-gray-300';
    };

    return (
        <label
            className={`${large ? 'w-8 h-6' : 'w-6 h-4'} ${calcBackground()}
                 rounded-xl mt-1 relative inline-block align-middle ${className}`}>
            <input
                type="checkbox"
                disabled={disabled}
                className="peer/draft opacity-0 w-0 h-0"
                checked={checked}
                onChange={(e) => !disabled && onChange(e.target.checked)}
            />
            <span
                className={`${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} absolute inset-0
                before:transition before:ease-out before:duration-200 rounded-[2.25rem] slider round
                before:content-['']  before:rounded-full before:bg-sf-white ${
                    large ? 'before:bottom-[3px]' : 'before:bottom-0.5'
                } before:absolute before:left-0.5 ${large ? 'before:w-[18px] before:h-[18px]' : 'before:w-3 before:h-3'}
                peer-checked/draft:before:bg-sf-white ${
                    large
                        ? 'peer-checked/draft:before:translate-x-[0.6rem]'
                        : 'peer-checked/draft:before:translate-x-[0.5rem]'
                }`}></span>
        </label>
    );
};
export default Toggle;
